import { render, staticRenderFns } from "./ContentProfileAnalyticsTwitch.vue?vue&type=template&id=8dc8966a&scoped=true&"
import script from "./ContentProfileAnalyticsTwitch.vue?vue&type=script&lang=js&"
export * from "./ContentProfileAnalyticsTwitch.vue?vue&type=script&lang=js&"
import style0 from "./ContentProfileAnalyticsTwitch.vue?vue&type=style&index=0&id=8dc8966a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc8966a",
  null
  
)

export default component.exports